import type { ResolvedStation } from '../interaction/stationResolver'
import type { SelectedStationSnapshot } from '../interaction/selectedStationSnapshot'

/**
 * Construct a `SelectedStationSnapshot` from a `ResolvedStation` returned
 * by `resolveStation` / `resolveStationBySlug`.
 *
 * Centralises the inline construction previously duplicated in
 * `UrlToStoreSync` (and which the new `RouteSelectionLocalStorageSync`
 * also needs). Field-by-field mirror of the schema record:
 *   - `id` ← station.id
 *   - `canvasX` ← station.x
 *   - `canvasY` ← station.y
 *   - `lineId` ← station.line.id
 *   - `localName` ← station.localName
 *
 * Hex color is intentionally NOT included — `SelectedStationSnapshot`
 * does not carry it (theme-dependent; UI resolves per render).
 */
export function stationSnapshotFromSchema(resolved: ResolvedStation): SelectedStationSnapshot {
  return {
    id: resolved.station.id,
    canvasX: resolved.station.x,
    canvasY: resolved.station.y,
    lineId: resolved.station.line.id,
    localName: resolved.station.localName,
    naptanId: resolved.station.naptanId,
  }
}
